import React from "react"
import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../theme/modern/tokens"

const useStyles = makeStyles((theme: ModernTheme) => ({
    kbd: {
        font: `600 10px ${theme.modern.mono}`,
        color: theme.modern.ink2,
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderBottomWidth: 2,
        borderRadius: 4,
        padding: "1.5px 5px",
    },
}));

/**
 * @param props
 */
export default function Kbd(props: {children: React.ReactNode}) {
    const styles = useStyles();

    return <kbd className={styles.kbd}>{props.children}</kbd>
}
